<template>
	<div class="header">
		<!-- 钱包余额 walletType 1充值 2提现 -->
		<el-dialog width="494px" :visible.sync="walletShow" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false"
			:show-close="false">
			<div class="my_info_box">
				<div class="my_info_top">
					<div class="my_info_top_title">
						Wallet
					</div>
					<div class="my_info_top_close">
						<img @click="closeWalletShow()" class="my_info_top_close_icon"
							src="../../../assets/icons/close_icon.png" alt="" />
					</div>
				</div>
				<div class="my_info_top_height">
				</div>
				<div class="header_wallet">
					<div class="header_wallet_tab_box">
						<div class="header_wallet_tab_item" v-for="item in walletTab" :key="item.id"
							@click="clickWalletType(item)" :class="item.id==walletType?'header_wallet_tab_item_h':''">
							{{item.name}}
						</div>
					</div>
					<div class="header_wallet_solid">
					</div>
					<div class="header_wallet_balance">
						<div class="header_wallet_balance_title">
							Available Balance
						</div>
						<div class="my_info_with_item_num">
							₦ {{user.balance?user.balance:0}}
						</div>
					</div>
					<!-- 充值页面 -->
					<div  v-if="walletType==1">
						<div class="header_wallet_banner">
							<img class="header_wallet_banner_img" src="../../../assets/image/header/wallet_banner1.png"
								alt="" />
						</div>
						<div class="header_wallet_paytype">
						<div class="header_wallet_paytype_title">
							Payment Methods
						</div>
						<div @click="clickSelectPaytype(1)" class="header_wallet_paytype_select">
								<div v-if="(walletType==2&&!curPayType.bankVo.payName)||(walletType==1&&!curBank.name)">
									Choose your Bank
								</div>
								<div v-else>
									<div v-if="walletType==1" class="flex">
										<img class="header_wallet_paytype_select_icon" :src="curBank.image" alt="" />
										<div class="header_wallet_paytype_select_name">
											<span>
												{{curBank.name}}
											</span>
										</div>
									</div>
									<div v-else class="flex">
										<img v-if="curPayType.bankVo&&curPayType.bankVo.payImage"
											class="header_wallet_paytype_select_icon" :src="curPayType.bankVo.payImage"
											alt="" />
										<div class="header_wallet_paytype_select_name">
											<!-- {{curPayType}} -->
											<span v-if="curPayType.bankVo && curPayType.bankVo.payName">
												{{ curPayType.bankVo.payName || curPayType.bankVo.backName }}
											</span>
										</div>
									</div>
								</div>
								<img class="header_wallet_paytype_bottom_icon" src="../../../assets/icons/bottom_icon.png"
									alt="" />
							</div>
						</div>
					</div>
					<!-- 提现页面 -->
					<div  v-if="walletType==2">

					</div>
					<div class="header_wallet_paytype">
						<div class="header_wallet_paytype_title">
							Payment Methods
						</div>
						<div @click="clickSelectPaytype(1)" class="header_wallet_paytype_select">
							<div v-if="(walletType==2&&!curPayType.bankVo.payName)||(walletType==1&&!curBank.name)">
								Choose your Bank
							</div>
							<div v-else>
								<div v-if="walletType==1" class="flex">
									<img class="header_wallet_paytype_select_icon" :src="curBank.image" alt="" />
									<div class="header_wallet_paytype_select_name">
										<span>
											{{curBank.name}}
										</span>
									</div>
								</div>
								<div v-else class="flex">
									<img v-if="curPayType.bankVo&&curPayType.bankVo.payImage"
										class="header_wallet_paytype_select_icon" :src="curPayType.bankVo.payImage"
										alt="" />
									<div class="header_wallet_paytype_select_name">
										<!-- {{curPayType}} -->
										<span v-if="curPayType.bankVo && curPayType.bankVo.payName">
											{{ curPayType.bankVo.payName || curPayType.bankVo.backName }}
										</span>
									</div>
								</div>
							</div>
							<img class="header_wallet_paytype_bottom_icon" src="../../../assets/icons/bottom_icon.png"
								alt="" />
						</div>
					</div>
					<div class="header_wallet_paytype">
						<div class="header_wallet_paytype_title color_667182">
							Min~Max: {{ withdrawLimit.configValue.split(',')[0] || 100 }} - {{ withdrawLimit.configValue.split(',')[1] || 100000 }} NGN
						</div>
						<div class="header_wallet_paytype_input">
							<el-input clearable @input="changeInput($event,1)" v-model="amount" type="number"
								placeholder="Amount(NGN)" />
						</div>
					</div>

					<div class="header_wallet_paytype" v-if="walletType==2">
						<div class="header_wallet_paytype_title">
							<!-- 提现账号 -->
							Account Number
						</div>
						<div class="header_wallet_paytype_input">
							<el-input clearable v-model="accountNumber" placeholder="Enter your Account Number" />
						</div>
					</div>


					<div v-if="walletType==1" class="header_wallet_amount_list">
						<div v-for="(item,index) in amountList" :key="index" class="header_wallet_amount_item"
							@click="clickAmountItem(item)"
							:class="`${(index+1)%3==0?'mar_r0':''} ${curAmountId==item.rechargeId?'header_wallet_amount_item_h':''}`">
							<img class="header_wallet_amount_item_hot_tag_icon"
								src="../../../assets/icons/hot_tag_icon.png" alt="" />
							<div class="header_wallet_amount_item_name flex">
								₦{{item.rechargePrice?item.rechargePrice:0}}
							</div>
							<div v-if="item.rechargePercent" class="header_wallet_amount_item_add">
								+{{item.rechargePercent}}%
							</div>
						</div>
					</div>
					<div  v-if="walletType==1" class="test_size">
						The maximum daily recharge gift limit is：{{ maxLimitData.configValue }}
					</div>
					<div v-if="walletType==2" @click="clickSelectPaytype(5)" class="header_wallet_setdef_bank">
						<!-- 更换默认银行卡 -->
						Change Default Bank
					</div>


					<div v-if="walletType==1" @click="clickDeposit(1)" class="def_btn mar_t20">
						Deposit
					</div>
					<div v-else @click="clickDeposit(2)" class="def_btn mar_t20 withdraw_btn">
						Withdraw
					</div>

					<div class="header_wallet_amount_remark">
						NB: There are no fees charged for Depositing <br>
						with this payment method. Once your transaction is authorized,<br>
						the amount will be credited to your account immediately.
						<br>
  						Note: Receive a 100% Bonus on your first deposit up to ₦10,000 and enjoy 5 Free Spins instantly.
					</div>
				</div>
			</div>
		</el-dialog>


		<!-- 选择支付方式 -->
		<el-dialog width="494px" :visible.sync="payTypeShow" @open="selectPayOpen" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="my_info_box">
				<div class="my_info_top">
					<div class="my_info_top_title">
						<span v-if="payTypeShowType!=3">
							Select Payment Method
						</span>
						<span v-else-if="payTypeShowType==3">
							Change Default Bank
						</span>
					</div>
					<div class="my_info_top_close">
						<img @click="clickSelectPaytype(2)" class="my_info_top_close_icon"
							src="../../../assets/icons/close_icon.png" alt="" />
					</div>
				</div>
				<div class="my_info_top_height">
				</div>
				<div class="header_wallet" :class="payTypeShowType!=3?'':'pad_t0 mar_t15'">
					<div v-if="payTypeShowType==1" class="header_wallet_edit">
						<span @click="delPayType=!delPayType">
							{{delPayType?'Cancel':'Edit'}}
						</span>
					</div>
					<!-- <div v-if="payTypeShowType!=3" class="header_wallet_paytype_input">
						<el-input clearable v-model="selectPayName" placeholder="Select Bank" />
					</div> -->

					<div class="header_paytype_list hide_scroll_bars">
						<div v-if="payTypeShowType==1">
							<div v-for="item in payTypeList1" :key="item.bankVo.name" class="header_paytype_item"
								@click="clickPaytypeItem(item)">
								<div class="flex">
									<img class="header_paytype_item_icon" :src="item.bankVo.payImage" alt="" />
								</div>
								<div class="header_paytype_item_name flex">
									<div>{{item.bankVo.payName}}</div>
								</div>
							</div>
						</div>
						<div class="header_paytype_item" v-for="item in payTypeList" :key="item.name"
							@click="clickPaytypeItem(item)">
							<div class="flex">
								<img v-if="(item.bankId==defPay.bankId&&payTypeShowType==3)||(item.bankId==curPayType.bankId&&payTypeShowType==1)"
									class="header_paytype_item_dui_icon" src="../../../assets/icons/dui_icon.png"
									alt="" />
								<img v-if="item.bankVo&&item.bankVo.payImage" class="header_paytype_item_icon"
									:src="item.bankVo.payImage" alt="" />
								<img v-else class="header_paytype_item_icon" :src="item.image" alt="" />

							</div>
							<div class="header_paytype_item_name flex">
								<div>{{item.name}}</div>
								<div v-if="payTypeShowType==1||payTypeShowType==3" class="flex mar_l10">
									<div>
										{{$use.desensitizeString(item.bankCode)}}
									</div>
									<div v-if="defBack.bankId==item.bankId" class="header_paytype_item_def_tag">
										Default
									</div>
								</div>
							</div>
							<div v-if="delPayType||payTypeShowType==3" @click.stop="clickDelPayItem(item)"
								class="header_paytype_item_del_icon_box">
								<img class="header_paytype_item_del_icon" src="../../../assets/icons/del_icon.png"
									alt="" />
							</div>
						</div>
						
						<div v-if="payTypeShowType==1" class="header_paytype_item" @click="clickAddPay(1)">
							<img class="header_paytype_item_icon" :src="require(`/src/assets/icons/add_icon2.png`)"
								alt="" />
							<div class="header_paytype_item_name">
								Add New Bank Account
							</div>
						</div>
					</div>
					<div v-if="payTypeShowType==3" @click="setDefPay()" class="def_btn">
						Confirm
					</div>

				</div>
			</div>
		</el-dialog>
		<!-- 二次确认提现内容 -->
		<el-dialog width="494px" :visible.sync="tooWithdrawShow" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="my_info_box">
				<div class="my_info_top">
					<div class="my_info_top_title">
						Confirm Withdrawal
					</div>
					<div class="my_info_top_close">
						<img @click="clickDeposit(3)" class="my_info_top_close_icon"
							src="../../../assets/icons/close_icon.png" alt="" />
					</div>
				</div>
				<div class="my_info_top_height">
				</div>
				<div class="header_wallet">
					<div class="too_withdraw_from">
						<div class="too_withdraw_from_item">
							<div class="too_withdraw_from_item_label">
								Remaining Amount
							</div>
							<div class="too_withdraw_from_item_value">
								₦ {{user.balance?user.balance:0}}
							</div>
						</div>
						<div class="too_withdraw_from_item">
							<div class="too_withdraw_from_item_label">
								Bank Name
							</div>
							<div class="too_withdraw_from_item_value">
								{{curPayType.bankName || curPayType.bankVo.payName}}
							</div>
						</div>
						<div class="too_withdraw_from_item">
							<div class="too_withdraw_from_item_label">
								Account Number
							</div>
							<div class="too_withdraw_from_item_value">
								{{accountNumber}}
								<!-- {{ $use.desensitizeString(curPayType.bankCode)}} -->
							</div>
						</div>
						<div class="too_withdraw_from_item">
							<div class="too_withdraw_from_item_label">
								Account Name
							</div>
							<div class="too_withdraw_from_item_value">
								{{curPayType.bankUserName}}
							</div>
						</div>
					</div>
					<div class="too_withdraw_price too_withdraw_from_item">
						<div class="too_withdraw_from_item_value">
							<div>
								Withdrawal
							</div>
							<div>
								(Amount)
							</div>
						</div>
						<div class="color_14EB74">
							₦{{amount?amount:0}}
						</div>
					</div>

					<div class="too_withdraw_btn_box too_withdraw_from_item">
						<div @click="clickDeposit(3)" class="too_withdraw_btn">
							Cancel
						</div>
						<div @click="clickDeposit(4)" class="too_withdraw_btn withdraw_btn">
							Confirm
						</div>
					</div>
				</div>
			</div>
		</el-dialog>


		<!-- 验证码弹出框 -->
		<el-dialog width="494px" :visible.sync="otpShow" :close-on-click-modal="false" :close-on-press-escape="false"
			:show-close="false">
			<div class="my_info_box otp_dialog">
				<div class="my_info_top" style="background-color: rgba(0,0,0,0);">
					<div class="my_info_top_title">
					</div>
					<div class="my_info_top_close">
						<img @click="otpShow = false" class="my_info_top_close_icon"
							src="../../../assets/icons/close_icon.png" alt="" />
					</div>
				</div>
				<div class="otp_dialog_content">
					<div class="header_tip_item_title">
						<span v-if="tipOperateType==2">
							Enter your payment PIN
						</span>
						<span v-else-if="tipOperateType==3">
							Confirm your account
						</span>
						<span v-else-if="tipOperateType==4">
							Enter OTP
						</span>
					</div>
					<div class="header_tip_item_remark mar_t18">
						<span v-if="tipOperateType==2">
							Your payment PIN must be 4-digits.
						</span>
						<span v-else-if="tipOperateType==3">
							Enter the email/phone no. you used to register
						</span>
						<span v-else-if="tipOperateType==4">
							A 6-digit code was sent to 邮箱或手机号
						</span>
					</div>

					<div class="header_tip_item_input_box">
						<div v-if="tipOperateType==2" class="header_verification_container">
							<input v-for="(code, index) in verificationCodes2" :key="index"
								v-model="verificationCodes2[index]" @input="handleInput(index, $event)"
								@keydown="handleKeyDown(index, $event)" maxlength="1"
								class="header_verification_input" />
						</div>
						<div v-else-if="tipOperateType==4" class="header_verification_container">
							<input v-for="(code, index) in verificationCodes" :key="index"
								v-model="verificationCodes[index]" @input="handleInput(index, $event)"
								@keydown="handleKeyDown(index, $event)" maxlength="1"
								class="header_verification_input" />
						</div>
						<div v-if="tipOperateType==3" class="header_wallet_paytype_input">
							<el-input clearable v-model="selectPayName" placeholder="Enter email/phone no." />
						</div>
					</div>


					<div @click="submitCode()" class="def_btn">
						Continue
					</div>
				</div>
			</div>
		</el-dialog>


		<!-- 签到弹窗 -->
		<!-- <signinDialog :show="signInShow" @close="signInShow=false"></signinDialog> -->

		<!-- vip礼包弹出框 -->
		<vipGiftPack :show="vipGiftPackShow" @close="vipGiftPackShow=false"></vipGiftPack>

		<!-- 分享链接 -->
		<recommendLinkDialog :show="recommendShow" @close="recommendShow=false"></recommendLinkDialog>

		<!-- 赌注历史 -->
		<betHistoryDialog :show="betHistoryShow" @close="betHistoryShow=false"></betHistoryDialog>

		<!-- 消息通知 -->
		<msgDialog :show="msgShow" @close="getUnreadNumber();msgShow=false"></msgDialog>

		<!-- 交易记录 -->
		<TransactionsDialog :show="TransactionsShow" @close="TransactionsShow=false"></TransactionsDialog>

		<!-- 个人信息 -->
		<setUserInfo :show="setUserInfoShow" @close="setUserInfoShow=false"></setUserInfo>


		<!-- 防沉迷 -->
		<selfExDialog :show="selfExShow" url="gameCollectList" @close="selfExShow=false"></selfExDialog>

		<!-- 防沉迷提示 -->
		<selfExTipDialog></selfExTipDialog>

		<!-- 账号认证 -->
		<div v-if="authenticationDialogShow">
			<authenticationDialog :show="authenticationDialogShow" @close="authenticationDialogShow = false">
			</authenticationDialog>
		</div>


	</div>
</template>
<script>
	import {
		mapState,
	} from 'vuex';

	import * as Url from "@/utils/Url";

	import signinDialog from './signinDialog.vue'
	import vipGiftPack from './vipGiftPack.vue'
	import recommendLinkDialog from './recommendLinkDialog.vue'
	import betHistoryDialog from './betHistoryDialog.vue'
	import msgDialog from './msgDialog.vue'
	import TransactionsDialog from './TransactionsDialog.vue'
	import setUserInfo from './setUserInfo.vue'
	import selfExDialog from './selfExDialog.vue'
	import selfExTipDialog from './selfExTipDialog.vue'
	import authenticationDialog from './authenticationDialog.vue'


	export default {
		components: {
			signinDialog,
			vipGiftPack,
			recommendLinkDialog,
			betHistoryDialog,
			setUserInfo,
			msgDialog,
			TransactionsDialog,
			selfExDialog,
			selfExTipDialog,
			authenticationDialog,

		},
		props: {
			walletShow: {
				type: Boolean,
				default: false
			},
		},
		computed: {
			...mapState(['user', 'token', 'selfType']), // 映射 user 模块下的 userInfo 状态
			thirdBankList() {
				if (!this.searchThird) return this.oldThirdBankList;
				const regex = new RegExp(this.searchThird, "i"); // 'i' 表示不区分大小写
				return this.oldThirdBankList.filter(item => regex.test(item.name));
			}
		},

		data() {
			return {
				eyeType: true, //是否显示金额
				isSeeMoney: true, //是否显示金额
				signInShow: false, //签到弹框
				vipGiftPackShow: false, //vip礼包弹框
				setUserInfoShow: false, //设置个人信息
				recommendShow: false, //推荐链接
				betHistoryShow: false, //赌注历史
				msgShow: false, //通知消息
				TransactionsShow: false, //交易记录
				selfExShow: false, //防沉迷
				selfExTipShow: true, //防沉迷提示
				authenticationDialogShow: false,



				msgNum: { //未读消息数
					noticeUnReadNumber: 0,
					activityUnReadNumber: 0,
				},
				loadingShow: null, //加载动画
				tipShow: false, //提示弹窗
				tipOperateType: 1, //提示弹操作类型 1充值 2提现  3输入账号使用验证码弹框otpShow  4验证码验证账号弹框  5创建密码
				tipType: 1, //提示弹窗类型 1充值成功  2提现成功 3充值失败  4绑定邮箱或手机号成功  5创建密码成功
				infoShow: false, //个人信息弹窗
				walletTab: [{
						id: 1,
						name: 'Deposit',
					},
					{
						id: 2,
						name: 'Withdraw',
					}
				],
				avatarMenu: [{
						id: 1,
						name: 'Wallet',
					},
					{
						id: 2,
						name: 'Profile',
					},
					{
						id: 3,
						name: 'Transactions',
					},
					{
						id: 4,
						name: 'Settings',
					},
					{
						id: 5,
						name: 'Referral link',
					},
					{
						id: 6,
						name: 'Bet History',
					},
					{
						id: 7,
						name: 'Self Exclusion',
					},
					{
						id: 8,
						name: 'Log Out',
					}
				],
				showSwapModal: false, //是否显示兑换弹窗
				walletType: 1, // 钱包弹窗类型 1充值 2提现
				amount: '', //充值金额
				accountNumber: '', //提现账号
				curAmountId: '', //当前选中的充值金额id
				payTypeShow: false, //选择支付方式弹出框
				payTypeShowType: 1, // 1选择自己的银行卡  2添加银行卡 选择银行  3设置默认选中银行  4 支付选择银行
				delPayType: false, //是否可以删除银行卡
				selectPayName: '', //支付方式搜索条件
				tooWithdrawShow: false, //二次提现内容弹窗
				otpShow: false, //输入验证码弹框
				verificationCodes: ['', '', '', '', '', ''], // 初始化验证码数组
				verificationCodes2: ['', '', '', '', ], // 支付密码
				addPayShow: false, //添加银行卡弹窗
				addPar: {
					bankName: '', //银行名称
					image: '', //银行图标
					payName: '', //银行编号
					bankCode: '', //银行卡号
					bankUserName: '', //银行预留用户名
					bankNameCode: '', //银行编码 银行不等于Opay时输入
					status: '', //
				},
				defPay: { //修改默认支付方式 暂存参数
					bankId: '',
					bankCode: '',
					bankName: '',
					image: '',
				},
				delPayId: '', //要删除的银行卡id
				defBack: { //默认银行卡
					bankId: '',
				},


				// 充值
				rechargePar: {
					rechargeId: '', //充值套餐id
					payType: '', //支付方式  可选
					bankId: '', //银行卡id
				},




				maxLimitData:{},
				curPayType: { //默认银行卡信息
					bankVo: {
						payImage: '',
						payName: '',
					},
					bankId: '',
					bankCode: '',
					bankName: '',
					image: '',
				},
				backList: [], //银行列表
				curBank: { //充值使用的默认银行信息
					name: '',
					image: '',
				},
				payEmail: '', //充值时使用的邮箱
				userBankList: [], //我绑定的支付方式列表
				searchBack: '', //搜索支付方式输入框
				payTypeList: [], //支付方式列表
				payTypeList1: [
					// {
					// 	bankCode: 'Opay',
					// 	name: 'Opay',
					// 	image: '',
					// 	code: '',
					// 	bankVo: {
					// 		payImage: 'https://d2s7353yldz2dq.cloudfront.net/2025/06/05/4e29db5d126a4eefb659d4a0db54d4cd.png',
					// 		payName: 'Opay',
					// 	}
					// },
					{
						bankCode: 'Palmpay',
						name: 'Palmpay',
						image: '',
						code: '',
						bankVo: {
							payImage: 'https://d2s7353yldz2dq.cloudfront.net/2025/06/05/e872246920b64b7c96c21824b9285316.png',
							payName: 'Palmpay',
						}
					}
				], //上线之前隐藏Opay

				amountList: [], //充值套餐列表
				// thirdBankList: [], //Paystack第三方银行列表
				searchThird: '',
				oldThirdBankList: [], //银行原列表
				openPage: null,
				amountAll:'',
				getInfoShow: true,
				withdrawLimit: {
					configValue:'100,50000'
				},
				withdrawMinLimit:{},
			}
		},
		mounted() {
			if (this.$storag.getStringData("token")) {
				this.$store.dispatch('GetToken')
				this.$store.dispatch('GetSelfType')
				this.$store.dispatch('GetInfo')
				// 获取银行列表
				this.getBankList()
				if (this.user && this.user.email) {
					this.payEmail = JSON.parse(JSON.stringify(this.user.email))
				}
				this.getListMax()
				this.getThirdBankList()
				this.getUnreadNumber()
			}

			document.addEventListener("visibilitychange", () => {
				if (document.visibilityState === 'visible') {
					if (this.$storag.getStringData("token")) {
						// 每次页面显示重新获取用户信息
						if (this.getInfoShow) {
							this.getInfoShow = false
							this.$store.dispatch('GetInfo').finally(() => {
								this.getInfoShow = true
							})
						}
					}
				}
			});


		},
		methods: {
			getListMax(){
				this.$api.getProductList().then((res)=>{
					this.maxLimitData = res.data.find(item => item.configKey === 'daily_recharge_bonus_max_limit');
					this.withdrawLimit = res.data.find(item => item.configKey == 'withdraw_limit');
					this.withdrawMinLimit = res.data.find(item => item.configKey == 'withdraw_min_limit');
				})
			},
			handleSubmit(){
				if (!/^[1-9]\d*\.\d{2}$|^0\.\d{2}$/.test(this.amountAll)) {
					this.$use.msg('Please enter a positive number','warning');
				}else{
					let par = {amount:this.amountAll}
					this.$api.giftToBalance(par).then(res => { 
						this.$use.msg('Swap Successful', 'success')
						this.showSwapModal = false
						this.amountAll = ''
						this.$store.dispatch('GetInfo')
					})
				}
				
			},
			handleClose(){
				this.showSwapModal = false
				this.amountAll = ''
			},
			openSwap(){
				this.showSwapModal = true
				this.amountAll  = this.user.cashback
			},
			navTo(url, que) {
				this.$router.push({
					name: url,
					query: que
				})
			},
			goHome() {
				if (this.$route.path != '/homePage') {
					this.navTo('homePage')
				}
			},
			// 点击左侧按钮
			clickHeaderLeft(type) {
				// if(this.selfType.status){
				// 	this.$store.dispatch('setSelfShow',true)
				// 	return
				// }

				if (type == 1) {
					// this.signInShow = true
				} else if (type == 2) {
					this.vipGiftPackShow = true
				}
			},
			// 点击头像菜单列表
			clickAmenuItem(item) {
				if (item.id == 1) {
					// 钱包
					this.infoShow = true
					
				} else if (item.id == 2) {
					// 个人信息 
					this.navTo('setpage', {
						type: 2
					})
				} else if (item.id == 3) {
					// 交易记录
					this.TransactionsShow = true
				} else if (item.id == 4) {
					// 设置
					this.navTo('setpage', {
						type: 1
					})
				} else if (item.id == 5) {
					// 推荐链接
					this.recommendShow = true
				} else if (item.id == 6) {
					// 赌注历史
					this.betHistoryShow = true
				} else if (item.id == 7) {
					// 防沉迷
					if (!this.user.email && !this.user.phonenumber) {
						this.$use.msg('Please bind your mobile phone number and email address first', 'error')
					} else {
						// if(this.selfType.status){
						// 	this.$store.dispatch('setSelfShow',true)
						// }else{
						// }
						this.selfExShow = true
					}
				} else if (item.id == 8) {
					// 退出登录StorageUtils
					let rememberMe = this.$storag.getStringData('rememberMe')
					this.$storag.setAccount()
					localStorage.clear()
					this.$store.dispatch('SetInfo', {})
					this.$storag.setStringData('rememberMe',rememberMe)
					this.navTo('login')
				}
			},
			// 获取未读消息数
			getUnreadNumber() {
				this.$api.getUnreadNumber({}).then(res => {
					this.msgNum = res.data
				})
			},
			// 点击提示框中的按钮
			clickTipBtn(type) {
				// type 2暂时只做关闭操作 
				if (type == 3) {
					this.tipType = 1
				} else if (type == 6) {
					// 确认删除银行卡
					this.removeUserBank()
					this.tipShow = false
				} else {
					this.tipShow = false
					this.closeWalletShow()
				}
			},
			// 设置默认绑定银行卡
			setDefPay() {
				this.$api.editDefBack({
					...this.defPay,
					status: 1
				}).then(res => {
					this.$use.msg('Binding successful', 'success')
				})
			},
			selectPayOpen() {
				// 选择银行卡弹窗
				if (this.payTypeShowType == 1 || this.payTypeShowType == 3) {
				} else if (this.payTypeShowType == 2 || this.payTypeShowType == 4) {
					// 银行列表只需要请求一次
					// this.getBankList()
					this.payTypeList = JSON.parse(JSON.stringify(this.backList))
				}
			},
			//获取Paystack第三方银行列表
			getThirdBankList() {
				this.$api.thirdBankList({
					clientId: Url.clientId,
				}).then(res => {
					// this.thirdBankList = res.data
					this.oldThirdBankList = res.data
				})
			},
			// 获取银行列表
			getBankList(type = 0) {
				this.$api.getBankList({}).then(res => {
					// 暂时添加默认项
					if (res.data.length>0) {
						this.curBank.name = res.data[0].name
						this.curBank.image = res.data[0].image

						this.addPar = {
							...this.addPar,
							...res.data[0]
						}
						this.backList = res.data
					}
				})
			},
			// 暂存删除银行卡
			clickDelPayItem(item) {
				this.delPayId = item.bankId
				this.tipType = 6
				this.tipShow = true
			},
			// 删除银行卡
			removeUserBank() {
				this.$api.removeUserBank({
					bankId: this.delPayId
				}).then(res => {
					this.$use.msg('Deletion successful', 'success')
					this.$track.track('unbindBankCard',{userId:this.user.userId});
					this.selectPayOpen()
				})
			},
			// 点击添加银行卡
			addUserBank() {
				// 银行编号  列表信息中暂无该信息
				this.addPar.payName = this.addPar.name
				if (!this.formMsg('payName')) {
					return;
				}
				if (!this.formMsg('bankUserName')) {
					return;
				}
				if (!this.formMsg('bankCode')) {
					return;
				}

				if (this.addPar.name == 'Paystack') {
					if (!this.formMsg('bankNameCode')) {
						return;
					}
				}
				this.$api.addUserBank(this.addPar).then(res => {
					this.$use.msg('Added successfully', 'success')
					this.$track.track('bindBankCard',{userId:this.user.userId});
					this.clickSelectPaytype(4)
				})
			},

			// 获取充值套餐列表
			getPackageList() {
				this.$api.getPackageList({}).then(res => {
					this.amountList = res.data
				})
			},
			// 点击钱包页面中的tab 选择充值或提现
			clickWalletType(item) {
				if (item.id == 2) {
					// 如果选择的是提现tab
					// if (!this.$storag.getStringData("isWallet")) {
					// }

					// 如果有支付密码						
					if (this.user.isPayPassword) {
					} else {
						// 如果没有支付密码 
						// isBindInfo 手机或邮箱其中一个绑定就返回true 两者都没绑定才会返回false
						if (!this.user.isBindInfo) {
							this.walletShow = false
							// 如果没有绑定账号
							this.$use.msg('Please bind your email or mobile phone number first', 'warning')
							setTimeout(() => {
								this.navTo('setpage', {
									type: 1
								})
							}, 800)
						} else {
							// 如果有绑定账号  做账号验证
							this.authenticationDialogShow = true
						}
						return
					}
					
				}
				this.amount = ''
				this.curAmountId = ''
				this.payEmail = ''
				this.tipOperateType = item.id
				this.walletType = item.id
			},
			// 点击选择充值金额
			clickAmountItem(item) {
				this.amount = item.rechargeNumber
				this.curAmountId = item.rechargeId
			},
			changeInput(e, type) {
				//type  1 监听充值金额输入框中的值  2监听选择支付方式输入框中的值
				if (type == 1) {
					// 如果值改变 清除选中金额高亮状态
					this.curAmountId = ''
				} else if (type == 2) {
					// 2监听选择支付方式输入框中的值

				}
			},
			// 跳转去个人信息
			goProfileInfo() {
				this.infoShow = false;
				this.setUserInfoShow = true;
				// // 个人信息
				// this.navTo('setpage', {
				// 	type: 1
				// })
			},
			// 关闭钱包弹窗并重置默认项
			closeWalletShow() {
				this.walletShow = false
				this.walletType = 1 // 钱包弹窗类型 1充值 2提现
				this.amount = 0 //充值金额
				this.curAmountId = '' //当前选中的充值金额id
				this.accountNumber = '' //提现账号
				this.verificationCodes = ['', '', '', '', '', ''] // 初始化验证码数组
				this.verificationCodes2 = ['', '', '', '', ] // 支付密码
				this.addPar.bankCode = '' //银行卡号
				this.addPar.bankUserName = '' //银行预留用户名
				this.addPar.bankNameCode = '' //银行编码 银行不等于Opay时输入
				this.curPayType =  {
					bankVo: {
						payImage: '',
						payName: '',
					},
					bankId: '',
					bankCode: '',
					bankName: '',
					image: '',
				}
				this.$emit('close', false)
			},
			// 点击打开钱包弹框 关闭个人信息弹框
			clickWalletShow(type) {
				if (type == 2) {
					// 如果有支付密码						
					if (this.user.isPayPassword) {

					} else {
						// 如果没有支付密码
						if (!this.user.isBindInfo) {
							this.walletShow = false
							// 如果没有绑定账号
							this.$use.msg('Please bind your email or mobile phone number firs', 'warning')
							setTimeout(() => {
								this.navTo('setpage', {
									type: 1
								})
							}, 800)
						} else {
							// 如果有绑定账号  做账号验证
							this.authenticationDialogShow = true
						}
						return
					}
				}

				this.walletType = type
				if (this.walletType == 1) {
					// 获取充值套餐
					// this.getBankList(1)
					this.getPackageList()
				} else {
					// 获取默认绑定银行卡
				}

				this.infoShow = false
				this.walletShow = true
			},
			// 打开/关闭充值方式列表
			clickSelectPaytype(type) {
				if (type == 1) {
					// 点击选择充值方式
					if (this.walletType == 1) {
						// 选择银行列表
						if (this.backList.length > 0) {
							this.payTypeList = JSON.parse(JSON.stringify(this.backList))
						} else {
							this.payTypeList = []
						}
						this.payTypeShowType = 4
					} else {
						// 选择自己的银行卡列表
						this.payTypeList = JSON.parse(JSON.stringify(this.userBankList))
						this.payTypeShowType = 1
					}
					this.walletShow = false
					this.payTypeShow = true
					this.tipOperateType = 1

				} else if (type == 2) {
					this.delPayType = false
					if (this.payTypeShowType == 1) {
						// 关闭充值方式打开 钱包弹窗
						this.payTypeShow = false
						this.walletShow = true
						this.tipOperateType = 2
					} else if (this.payTypeShowType == 2) {
						// 如果是从添加银行卡界面打开的选择银行卡弹窗
						this.payTypeShow = false
						this.addPayShow = true
					} else if (this.payTypeShowType == 3) {
						this.payTypeShow = false
						this.walletShow = true
					} else if (this.payTypeShowType == 4) {
						this.payTypeShow = false
						this.walletShow = true

					}
				} else if (type == 3) {
					// 添加银行卡页面打开 选择银行弹窗
					this.payTypeShowType = 2
					this.walletShow = false
					this.payTypeShow = true
					this.tipOperateType = 1
					this.payTypeList = JSON.parse(JSON.stringify(this.backList))
				} else if (type == 4) {
					// 添加银行卡页面打开 选择银行弹窗
					this.addPar.bankCode = ''
					this.addPar.bankUserName = ''
					this.addPar.bankNameCode = ''
					setTimeout(() => {
						this.payTypeShowType = 1
						this.addPayShow = false
						this.payTypeShow = true
					}, 200)
				} else if (type == 5) {
					this.defPay = {}
					// 设置默认选中银行
					this.payTypeShowType = 3
					this.delPayType = true
					this.walletShow = false
					this.payTypeShow = true
				}
			},
			// 点击银行列表
			clickThirdBank(item) {
				this.curPayType.name = 'Paystack'
				this.curPayType.image = ''
				this.curPayType.bankVo = {
					...item.bankVo,
					image: ''
				}
				this.curPayType.bankVo.payImage = ''
				this.curPayType.bankVo.payName = 'Paystack'
				this.curPayType.bankVo.backName = item.name
				this.curPayType.bankVo.payCode = 'Paystack'
				this.curPayType.bankVo.bankNameCode = item.code
				this.curPayType.code = item.code
				this.curPayType.bankVo.backId = item.id

				this.addPayShow = false
				this.walletShow = true
				this.tipOperateType = 2
			},
			// 确认选择充值方式
			clickPaytypeItem(item) {
				this.delPayType = false
				if (this.payTypeShowType == 1) {
					// 提现 选择自己的银行卡
					if (item.bankVo) {
						this.curPayType = item
					} else {
						let imgUrl = ''
						if (item.payName == "Palmpay") {
							imgUrl =
								'https://d2s7353yldz2dq.cloudfront.net/2025/06/05/e872246920b64b7c96c21824b9285316.png'
						} else if (item.payName == "Opay") {
							imgUrl =
								'https://d2s7353yldz2dq.cloudfront.net/2025/06/05/4e29db5d126a4eefb659d4a0db54d4cd.png'
						}
						this.curPayType = {
							...item,
							bankVo: {
								payImage: imgUrl,
								payName: item.payName,
							}
						}
					}
					this.clickSelectPaytype(2)
				} else if (this.payTypeShowType == 2) {
					// 添加银行卡时  选择银行
					this.addPar = {
						...this.addPar,
						...item
					}
					this.clickSelectPaytype(2)
				} else if (this.payTypeShowType == 3) {
					// 暂存预选中 设置默认银行卡  选择自己的银行卡
					this.defPay = item
				} else if (this.payTypeShowType == 4) {
					// 充值 选择银行卡
					this.curBank = {
						...item
					}
					this.payTypeShow = false
					this.walletShow = true
					this.tipOperateType = 2
				}
			},
			// 点击打开或关闭添加银行卡弹窗
			clickAddPay(type) {
				this.delPayType = false
				// type 1打开 2关闭
				if (type == 1) {
					this.payTypeShow = false
					this.addPayShow = true
				} else if (type == 2) {
					this.addPayShow = false
					this.payTypeShow = true
				}
			},
			// 点击确认充值||提现
			clickDeposit(type) {
				if (type == 1) {
					this.walletShow = false
					this.rechargeOrder()
				} else if (type == 2) {
					if (!this.formMsg('curAmountId')) {
						return;
					}
					if (!this.formMsg('accountNumber', this.accountNumber)) {
						return;
					}

					// this.walletShow = false
					// // 提现
					// this.tooWithdrawShow = true
					
					if (this.curPayType.payCode == 'Opay' || this.curPayType.bankCode == "Opay") {
						this.$api.checkAccountNumber({
							bankCode: this.accountNumber
						}).then(res => {
							this.curPayType.bankUserName = res.data.bankUserName
							this.curPayType.bankName = res.data.bankName
							this.walletShow = false
							// 提现
							this.tooWithdrawShow = true
						})
					} else if (this.curPayType.payCode == "Palmpay" || this.curPayType.bankCode == "Palmpay") {
						this.$api.queryAccount({
							bankCode: this.accountNumber
						}).then(res => {
							this.curPayType.bankId = res.data.bankId
							this.curPayType.bankUserName = res.data.bankUserName
							this.curPayType.bankName = res.data.bankName?res.data.bankName:this.curPayType.bankName
							this.walletShow = false
							// 提现
							this.tooWithdrawShow = true
						})
					} else {
						this.$api.checkBank({
							bankCode: this.accountNumber,
							bankNameCode: this.curPayType.bankNameCode?this.curPayType.bankNameCode:this.curPayType.code,
							payCode: 'Paystack',
							bankName: this.curPayType.bankName?this.curPayType.bankName:this.curPayType.name,
						}).then(res => {
							this.curPayType.bankId = res.data.bankId
							this.curPayType.bankUserName = res.data.bankUserName
							this.curPayType.bankName = res.data.bankName
							this.walletShow = false
							// 提现
							this.tooWithdrawShow = true
						})
					}
					// 提现埋点
					this.$track.track('withdrawal',{
						amount:this.amount,
						rechargeChannels:this.curPayType.bankName?this.curPayType.bankName:this.curPayType.name,
						userId:this.user.userId
					});
					this.$use.sendGoogleEvent('withdrawal')
				} else if (type == 3) {
					// 点击取消验证二次提现
					this.tooWithdrawShow = false
					this.walletShow = true
				} else if (type == 4) {
					// 点击开始二次提现验证  发送验证码
					this.tooWithdrawShow = false
					this.otpShow = true
				}
			},
			// 点击创建充值订单
			rechargeOrder() {
				// if (!this.formMsg('bankId')) {
				// 	return;
				// }

				// 充值
				let par = {}
				if (!this.formMsg('curAmountId')) {
					return;
				}
				if (this.curAmountId) {
					// 充值套餐id
					par = {
						payName: this.curBank.name,
						rechargeId: this.curAmountId
					}
				} else {
					// 充值金额
					par = {
						payName: this.curBank.name,
						rechargeNumber: this.amount
					}
				}

				// 这种支付方式需要添加
				let par2 = {}
				if (this.curBank.name == 'Paystack') {
					par2 = {
						email: this.payEmail
					}
				}


				if(this.applyData && this.applyData.length > 0){
					// 获取赠送金额
					if (this.money <= 0) return;
					// 找到最接近但 ≤ money 的套餐
					for (let i = this.applyData.length - 1; i >= 0; i--) {
						if (this.money >= this.applyData[i].rechargePrice) {
						this.matchedPackage = this.applyData[i];
						break;
						}
					}
					if (this.matchedPackage) {
						this.giftAmount =  this.matchedPackage.rechargePrice * (this.matchedPackage.rechargePercent / 100)
					}
				}
				this.loadingShow = this.$loading({
					fullscreen: true
				});
				this.$api.rechargeOrder({
					...par,
					...par2,
					returnUrl: 'https://www.lky7bet.com/#/pages/paycallback',
				}).then(res => {
					this.orderSign({
						rechargeOrderNo: res.data.rechargeOrderNo,
						payName: this.curBank.name
					})
					// 充值埋点
					this.$track.track('recharge',{
						amount:this.amount,
						rechargeChannels:this.curBank.name,
						userId:this.user.userId,
						giftAmount:this.giftAmount || 0,
					});
					this.$use.sendGoogleEvent('recharge')
				}).finally(() => {
					this.loadingShow.close();
				})
				// this.tipType = 3
				// this.tipShow = true
			},
			// 订单充值
			orderSign(par) {
				this.$api.orderSign(par).then(res => {

					let url = ''
					if (par.payName == 'Palmpay') {
						url = res.data.checkoutUrl
					} else if (par.payName == "Opay") {
						url = res.data.cashierUrl
					} else if (par.payName == "Paystack") {
						url = res.data.authorization_url
					}

					window.open(url, '_blank');
				})
			},
			// 验证码
			handleInput(index, event) {
				let verName = 'verificationCodes'
				if (this.tipOperateType == 4) {
					verName = 'verificationCodes'
				} else if (this.tipOperateType == 2) {
					verName = 'verificationCodes2'
				}
				let value = event.target.value;
				this[verName].splice(index, 1, value); // 更新当前输入框的值

				// 自动跳到下一个输入框
				if (value && index < this[verName].length - 1) {
					const nextInput = event.target.nextElementSibling;
					if (nextInput) {
						this.$nextTick(() => {
							nextInput.focus();
						});
					}
				}
			},
			handleKeyDown(index, event) {
				// 处理删除操作
				if (event.key === 'Backspace' && !event.target.value && index > 0) {
					const prevInput = event.target.previousElementSibling;
					if (prevInput) {
						this.$nextTick(() => {
							prevInput.focus();
						});
					}
				}
			},
			submitCode() {
				let par = {}

				let verName = 'verificationCodes'
				if (this.tipOperateType == 4) {
					verName = 'verificationCodes'
				} else if (this.tipOperateType == 2) {
					verName = 'verificationCodes2'
				}
				const code = this[verName].join(''); // 拼接验证码
				if (this.tipOperateType == 4) {
					if (code.length === 6) {
						// 在这里可以添加其他逻辑，例如调用 API 验证验证码
						this.continueOtp()
					} else {
						this.$use.msg('Please enter the complete Captcha', 'error')
					}
				} else if (this.tipOperateType == 2) {
					if (code.length === 4) {
						par = {
							bankId: this.curPayType.bankId,
							balance: this.amount, //提现数量
							payName: this.curPayType.name,
							payCode: this.curPayType.name || this.curPayType.payCode, //支付类型
							bankCode: this.accountNumber, //提现账号(opay=手机号=+23433334444)
							payPassword: code, //支付密码
							bankUserName: this.curPayType.bankUserName, //提现姓名(OPAY时必须) 通过接口获取
						}
						this.continueOtp(par)
					} else {
						this.$use.msg('Please enter the complete Captcha', 'error')
					}
				}

			},
			// 点击验证验证码||支付密码
			continueOtp(par) {
				this.$api.applicationWithdrawal(par).then(res => {
					if (this.tipOperateType == 4) {
						// 验证码
					} else if (this.tipOperateType == 2) {
						this.$store.dispatch('GetInfo')
						// 支付密码
						this.otpShow = false
						this.tipType = 2
						this.tipShow = true
					}

				})
			},
			// 关闭提现弹窗
			closeTooWithdraw() {
				this.tooWithdrawShow = false
				this.walletShow = true
			},


			formMsg(name, field = null) {
				let type = true;
				switch (name) {
					case 'bankName':
						if (this.addPar.bankName == '' || this.addPar.bankName.trim() == '') {
							return this.$use.msg('Please select a bank.', 'error')
							type = false
						}
						break;
					case 'bankCode':
						if (this.addPar.bankCode == '' || this.addPar.bankCode.trim() == '') {
							return this.$use.msg('Please enter the bank card number', 'error')
							type = false
						}
						break;
					case 'payName':
						if (this.addPar.payName == '' || this.addPar.payName.trim() == '') {
							return this.$use.msg('Please select a bank.', 'error')
							type = false
						}
						break;
					case 'bankUserName':
						if (this.addPar.bankUserName == '' || this.addPar.bankUserName.trim() == '') {
							return this.$use.msg('Please enter the reserved username of the bank', 'error')
							type = false
						}
						break;
					case 'bankNameCode':
						if (this.addPar.bankNameCode == '' || this.addPar.bankNameCode.trim() == '') {
							return this.$use.msg('Please enter bank code', 'error')
							type = false
						}
						break;
					case 'bankId':
						if (this.curPayType.bankId == '') {
							return this.$use.msg('Please select a bank card.', 'error')
							type = false
						}
						break;
					case 'curAmountId':
						if (this.curAmountId == '' && !this.amount) {
							// 充值金额  判断充值套餐id是否为空或充值金额是否为0
							return this.$use.msg('Please enter or select the recharge amount', 'error')
							type = false
						}
						break;
					case 'payEmail':
						if (this.payEmail == '' && !this.amount) {
							// 充值金额  判断充值套餐id是否为空或充值金额是否为0
							return this.$use.msg('Please enter the reserved username of the bank', 'error')
							type = false
						} else if (!this.$use.isValidEmail(this.payEmail)) {
							return this.$use.msg('Please enter a valid email address', 'error')
							type = false
						}
						break;
					case 'accountNumber':
						if (field == '' || field.trim() == '') {
							// 如果没有填写预留账号
							return this.$use.msg('Please enter your account password.', 'error')
							type = false
						}
						break;

					default:
						type = true
						return type; // 默认返回 true
				}
				return type
			},



		},
	}
</script>
<style lang="scss">
	.header_avatar_menu {
		.el-dropdown-menu__item:hover {
			background: #1F242F !important;
			color: #18D065 !important;
		}
	}

	.el-dialog {
		background: #1F242F !important;
		border-radius: 18px !important;
		line-height: 20px;
	}

	.header_wallet_paytype_input {
		.el-input__inner {
			height: 50px !important;
			background: #161A22 !important;
			border: none !important;
			font-size: 16px;
			color: #667182 !important;
			border-radius: 11px !important;
		}
	}
	.my_info_with_box_total {
		width: 424px;
		height: 82px;
		background: linear-gradient( 295deg, rgba(26,30,39,0) 0%, rgba(18,76,37,0.65) 54%, rgba(22,246,85,0.65) 100%);
		color: #9ECE9B;
		border-radius: 13px;
		padding: 16px 12px;
		margin-top: 30px;
		cursor: pointer;
	}
	.my_info_with_item_solid_box {
		color: #9ECE9B;
		font-size: 15px;
		font-weight: 600;
		display: flex;
		align-items: center;
	}
	.my_info_img {
		width: 12px;
		height: 12px;
		margin-left: 5px;
	}
	.my_info_img_icon {
		width: 12px;
		height: 12px;
		color: #9ECE9B;
	}
	.my_info_with_box {
		margin-top: 22px;
		font-size: 17px;
		font-weight: 600;
		color: #fff;
		letter-spacing:1px;
	}
	.subBox{
		position: absolute;
		top: 100px;
		width: calc(100% - 30px);
		
		.subBox2{
			width: 120px;
			height: 60px;
			border-radius: 8px;
			background-color: #9AF19E;
			
			.swapBtn{
				color: white;
				width: 32px;
				height: 13px;
				font-size: 8px;
				border-radius: 3px;
				cursor: pointer;
				background: #124C25;
			}
		}
	}


</style>
<style lang="scss" scoped>
	@import url('../../../assets/styles/layout/header.scss');
	.test_size {
		color: #fff;
		font-size: 24rpx;
	}
	.plr25 {
		padding-left: 13px;
		padding-right: 13px;
	}
	.flex {
		display: flex;
	}
	.align-center {
		align-items: center;
	}
	.flex-between {
		justify-content: space-between;
	}
	.text-center {
		text-align: center;
	}
	.cl-black {
		color: #000;
	}
	.fs16 {
		font-size: 8px;
	}
	.mt20 {
		margin-top: 10px;
	}
	.mt12 {
		margin-top: 12px;
	}
	.mt10 {
		margin-top: 5px;
	}
	.flex-center-center {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.fs20 {
		font-size: 16px;
	}
	.mt42 {
		margin-top: 22px;
	}
	.ml10 {
		margin-left: 10px;
	}
	.po-rela {
		position: relative;
	}
	.pb100 {
		padding-bottom: 50px;
	}
	::v-deep .el-dialog__title {
		color: #91A1BC;
	}
	.disabled_hs{
		opacity: 0.6;
	}
</style>